import { render, staticRenderFns } from "./BundleItems.vue?vue&type=template&id=1b9ef3d1&scoped=true&"
import script from "./BundleItems.vue?vue&type=script&lang=js&"
export * from "./BundleItems.vue?vue&type=script&lang=js&"
import style0 from "./BundleItems.vue?vue&type=style&index=0&id=1b9ef3d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ef3d1",
  null
  
)

export default component.exports